<template>
  <th v-if="isHeader">
    {{'Actions' | translate}}
  </th>
  <td v-else>
    <div class="custom-actions">
      <button class="btn btn-primary mb-1 edit-button" @click="itemAction('edit', rowData, rowIndex)"><i class="icons icon-note"></i></button>
      <form style="display:inline-block; vertical-align:middle" :action="$store.getters.apiUrl + '/printpicklist/' + rowData.id" target="_blank" method="POST">
        <input name="token" type="hidden" :value="$auth.token()"></input>
        <button type="submit" class="btn btn-primary mb-1 print-button" @click="itemAction('print', rowData, rowIndex)" style="cursor:pointer">
            <i class="icons icon-printer"></i>
        </button>
      </form>
      <button class="btn btn-danger mb-1 delete-button" @click="itemAction('delete', rowData, rowIndex)"><i class="icons icon-trash"></i></button>
    </div>
  </td>
</template>

<script>
import VuetableFieldMixin from 'vuetable-2/src/components/VuetableFieldMixin'

export default {
  mixins: [VuetableFieldMixin],
  props: {
    rowData: {
      type: Object,
      required: true
    },
    rowIndex: {
      type: Number
    }
  },
  methods: {
    itemAction (action, data, index) {
      if (action === 'delete') {
        if (confirm(this.$t('Are you sure?'))) {
          this.$router.push({ path: '/picklist/' + action + '/' + data.id })
        }
      } else if (action === 'print') {
        this.$parent.$parent.$parent.$refs.picklisttable.$refs.vuetable.selectId(data.id)
        // console.log(this.$parent.$parent.$parent.$refs.workordertable.$refs.vuetable)
        // window.open('/#/print/workorder/' + data.id, '_blank')
      } else {
        this.$router.push({ path: '/picklist/' + action + '/' + data.id })
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// PicklistListActions.vue?978ae6e4